import { create, type StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export interface ReportsV2Slice {
    reportsV2: boolean
}

export const createReportsV2Slice: StateCreator<ReportsV2Slice, [], [], ReportsV2Slice> = (set) => ({
    reportsV2: true,
})

export const useReportsV2Store = create<ReportsV2Slice>()(
    persist(
        devtools(createReportsV2Slice as any, {
            name: 'ReportsV2Store',
        }),
        { name: 'edge-reports-v2' },
    ),
)

export const useReportsV2 = () => useReportsV2Store((state) => state.reportsV2)
export const getReportsV2State = () => useReportsV2Store.getState().reportsV2
export const setReportsV2 = (state: boolean) => useReportsV2Store.setState({ reportsV2: state })
export const toggleReportsV2 = () => setReportsV2(!getReportsV2State())
